import styled from 'styled-components';

export const LockedFieldset = styled.fieldset`
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0.6;
  pointer-events: none;
`;
